import jwtDecode from 'jwt-decode';
// import { TextEncoder, TextDecoder } from 'util';
import store from '@/assets/js/store';
import { BASE_URL } from './config';
const crypto = require('crypto');
import { getIdpTokens } from '@/assets/js/api/current-user';

function loginExempt(to) {
  const whitelist = [
    'home',
    'instances',
    'clusters',
    'gpu',
    'instance-overview',
    'images',
    'key-pairs',
    'snapshots',
    'orchestration',
    'object-store',
    'object-store-overview',
    'volume-store',
    'volume-store-overview',
    'networks',
    'ip-addresses',
    'security-groups',
    'load-balancers',
    'post-login',
    'sign-up',
    'pre-accept-invitation',
    'kubernetes',
    'dns',
    'auth',
    'containers',
    'networkTopo',
    'ports',
    'routers',
    'databases',
    'file-store',
    'backups',
    'access-credentials',
    'app-credentials',
    'secrets',
    'credentials',
    'team-credentials',
    'usage',
    'billing',
    'invoices',
    'quota',
    'post-emk',
  ];

  return whitelist.indexOf(to.name) > -1;
}

function clearPages(to) {
  const whitelist = [
    'post-login',
    'sign-up',
    'pre-accept-invitation',
    'auth',
    'post-emk',
  ];

  return whitelist.indexOf(to.name) > -1;
}

async function fetchRevision() {
    const response = BASE_URL.includes('staging') ? await fetch(`${BASE_URL}/static/revision.txt`) : await fetch('https://my.fuga.cloud/revision.txt');
    const newData = await response.text();
    let oldVersion = localStorage.getItem('portalVersion')
    checkRevision(oldVersion, newData);
}

async function checkRevision(oldVersion, newData) {
    if (!oldVersion || oldVersion !== newData) {
        localStorage.setItem('portalVersion', newData)
        location.reload(true);
    }
}

export function getAccessToken(emk) {
  let idpTokenData = false;
  if (emk) {
    idpTokenData = localStorage.getItem('emk_token');
  } else {
    idpTokenData = localStorage.getItem('idp_token');
  }
  idpTokenData = JSON.parse(idpTokenData);
  return idpTokenData.access_token;
}

export function getRefreshToken() {
  let idpTokenData = localStorage.getItem('idp_token');
  idpTokenData = JSON.parse(idpTokenData);
  return idpTokenData.refresh_token;
}

export function getIdToken(decodeToken) {
  let idpTokenData = localStorage.getItem('idp_token');
  idpTokenData = JSON.parse(idpTokenData);
  if (decodeToken) {
    return jwtDecode(idpTokenData.id_token)
  }
  return idpTokenData.id_token;
}

// Helper function that will allow us to extract the access_token and id_token
function getParameterByName(name) {
  let match = RegExp('[#&]' + name + '=([^&]*)').exec(window.location.hash);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}

export function isLoggedIn() {
  let idpTokenData = localStorage.getItem('idp_token');
  idpTokenData = JSON.parse(idpTokenData);
  // console.log('checek token', idpTokenData)
  if (idpTokenData) {
    let isExpired = idpTokenData.expires_in < new Date().getTime();
    // console.log('checek token isExpired', Number(idpTokenData.expires_in));
    if (!isExpired) {
      store.commit('misc/CHANGE_LOGGED_IN_STATE', true);
      return true;
    } else {
      localStorage.removeItem('idp_token')
      store.commit('misc/CHANGE_LOGGED_IN_STATE', false);
      return false;
    }
  }
}

export function saveQueryString() {
  let queryString = new URLSearchParams(window.location.search);
  let data = {}
  data.code = queryString.get('code');
  return data;
}

export async function handleAuthentication(callback) {
    if (window.location.pathname === "/post-login") {
        let data = saveQueryString();
        if (!data.code) {
          localStorage.removeItem('idp_token');
          window.location = '/';
        } else {
          await getIdpTokens(data.code)
            .then((response) => {
              tokensToLocalStorage(response.data)
          })
        }
        callback();
    } else {
        setTimeout(() => {
            window.location = '/';
        }, 1000);
    }
}

export function tokensToLocalStorage(data, emk) {
    data.expires_in = data.expires_in * 1000 + new Date().getTime();
    if (emk) {
      localStorage.setItem('emk_token', JSON.stringify(data));
    } else {
      localStorage.setItem('idp_token', JSON.stringify(data));
    }
    return data;
}

export function getAuthorization(register, login) {
    let PKCECodes = generatePKCECodes();

    if (PKCECodes.codeVerifier) {
        localStorage.setItem('codeVerifier', PKCECodes.codeVerifier);
    }

    let redirectUri =  BASE_URL + '/post-login';
    let clientId = '268112946150834970@fuga-production';
    let types = 'code';
    let codeChallenge = PKCECodes.codeChallenge;
    let codeChallengeMethod = 'S256';
    let scope = 'openid email profile offline_access urn:zitadel:iam:org:project:id:zitadel:aud';
    let url = `https://identity.fuga.cloud/oauth/v2/authorize?client_id=${ clientId }&response_type=${ types }&code_challenge=${ codeChallenge }&code_challenge_method=${ codeChallengeMethod }&redirect_uri=${ redirectUri }&scope=${ scope }`;

    if (register) {
      url += '&prompt=create';
    } else if (login) {
      url += '&prompt=login';
    }
    window.location = url;
}

export function requireAuth(to, from, next) {
  if (to.name === "sign-up") {
    getAuthorization(true);
    return
  } else if (window.location.pathname !== "/post-login") {
    fetchRevision();
  }
  if (!isLoggedIn()) {
    if (loginExempt(to)) {
        if (localStorage.getItem('hasLoggedIn') && localStorage.getItem('hasLoggedIn') === 'true' && !clearPages(to)) {
          getAuthorization()
        } else {
          next();
        }
    } else {
      getAuthorization()
    }
  } else {
    next();
  }
}

function generateCodeVerifier() {
  const array = new Uint8Array(32);
  crypto.randomFillSync(array);
  return base64UrlEncode(array);
}

function base64UrlEncode(buffer) {
  return Buffer.from(buffer)
      .toString('base64')
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
}

function generateCodeChallenge(codeVerifier) {
  return base64UrlEncode(crypto.createHash('sha256').update(codeVerifier).digest());
}

function generatePKCECodes() {
  const codeVerifier = generateCodeVerifier();
  const codeChallenge = generateCodeChallenge(codeVerifier);
  return { 
    'codeVerifier': codeVerifier,
    'codeChallenge': codeChallenge 
  };
}